<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li class="flex items-center ml-4">
            <router-link :to="{ path: '/systemEnum' }" class="mr-2 vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("system.label.View") }} {{ enumName }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData()"
                      size="small"
                      >{{ $t("system.label.Edit") }}</vs-button
                    >
                    <!-- <vs-button
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                      type="border"
                      @click="deleteProvisioningPopup = true"
                      size="small"
                      >{{ $t("system.label.Delete") }}</vs-button
                    > -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <vs-table
              :data="viewEnumConfig"
              :description="false"
              description-title="Registries"
              description-connector="of"
              description-body="Pages"
            >
              <template slot="thead">
                <vs-th>{{ $t("system.label.Id") }}</vs-th>
                <vs-th>{{ $t("system.label.Property") }}</vs-th>
                <vs-th>{{ $t("system.label.Value") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="viewEnumConfig"
                  v-for="(enumDataId, index) in data"
                >
                  <vs-td :data="enumDataId.id">{{ enumDataId.id }}</vs-td>
                  <vs-td :data="enumDataId.type">{{ enumDataId.type }}</vs-td>
                  <vs-td :data="enumDataId.value">{{ enumDataId.value }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteProvisioningPopup"
      :title="$t('system.label.ENUM')"
      @deletePressed="deleteCodesData()"
      @cancelPressed="deleteProvisioningPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      breadcrumbs: [
        { name: "System", to: "" },
        { name: this.$t("ENUM"), to: "/systemEnum" },

        {
          name: `${this.$t("system.label.View")}  ${this.$route.params.name}`,
          to: "/",
        },
      ],
      deleteProvisioningPopup: false,
    };
  },
  computed: {
    ...mapState({
      viewEnumConfig: (state) => state.configuration.viewEnumConfig,
    }),
  },
  methods: {
    async enumDataByName() {
      try {
        await this.$store.dispatch(
          "configuration/fetchViewEnumData",
          this.enumName
        );
      } catch (error) {
        error;
      }
    },
    editData() {
      this.$router.push({
        name: "Edit Enum",
        params: { name: this.enumName },
      });
    },
    // async deleteCodesData() {
    //   try {
    //     this.deleteProvisioningPopup = false;
    //     await deleteManageCodesData(this.id);
    //     this.$router.push(`/manageCodesList`);
    //   } catch (error) {
    //     throw Error(
    //       error.message.errors[0].defaultUserMessage ||
    //         `Api failed with status code: ${error.message.httpStatusCode}`
    //     );
    //   }
    // },
  },
  filters: {},
  created() {
    this.enumName = this.$route.params.name;
    this.enumDataByName();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
